import { Purchase } from '@domain'

export type DirectDealsReq = {
	status?: DirectDealStatus
}

export type DirectDealReq = {
	stocked?: 'ALL' | 'STOCKED' | 'NOT_STOCKED'
}

export enum DirectDealCategory {
	RECOMMEND = 'RECOMMEND',
	DECLINE = 'DECLINE',
}

export enum DirectDealStatus {
	ALL = 'ALL',
	ACCEPTED = 'ACCEPTED',
	PENDING = 'PENDING',
	REJECTED = 'REJECTED',
}

export type DirectDealsOverview = {
	total: number
	accepted: number
	pending: number
	rejected: number
	acceptedAnnualTotalSavings: number
}

export type DirectDealSummary = {
	id: Id
	marketBasketId: Id
	manufacturerPlid: string
	manufacturerName: string
	customerPlid: string
	customerName: string
	coverage: number
	stocking: number
	annualTotalSavings: number
	annualRebateSavings: number
	annualPriceSavings: number
	annualSavingsPercent: number
	exactCoverage: number
	exactAnnualPriceSavings: number
	exactAnnualRebateSavings: number
	exactAnnualTotalSavings: number
	category: DirectDealCategory
	status: DirectDealStatus
}

export type DirectDealPurchaseCounts = {
	total: number
	stocked: number
	notStocked: number
}

export type DirectDeal = {
	summary: DirectDealSummary
	purchases: Purchase[]
	purchaseCounts: DirectDealPurchaseCounts
}
